import { Component } from '@angular/core';
import { HomePage } from './pages/home/home';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
	rootPage:any = HomePage;
  
	constructor(public loader:LoadingBarService){

	}
 
	ngOnInit() {

	}
	
}
